module.exports = __webpack_public_path__ + "img/list_img6.ca33aa1b.jpg";